const BUS_LAYOUTS = {
  Elite: {
    type: 'Elite',
    totalSeats: 34,
    seatsPerRowLeft: 2,
    seatsPerRowRight: 1,
    columns: ['A', 'B', 'C'],
    totalRows: 12,
    maxSelectableRow: 4,
    specialCells: {
      '1B': { type: 'empty' },
      '12C': { type: 'restroom' }
    }
  },
  Standard: {
    type: 'Standard',
    totalSeats: 55,
    seatsPerRowLeft: 2,
    seatsPerRowRight: 2,
    columns: ['A', 'B', 'C', 'D'],
    totalRows: 14,
    maxSelectableRow: 5,
    specialCells: {
      '14D': { type: 'restroom' }
    }
  }
};

const SEAT_PRICE_TIERS = {
  Elite: [
    { name: 'Premium', rows: [1, 2], additionalPrice: 12, description: 'Front rows with extra legroom' },
    { name: 'Preferred', rows: [3, 4], additionalPrice: 10, description: 'Mid-front rows' }
  ],
  Standard: [
    { name: 'Premium', rows: [1, 2, 3], additionalPrice: 12, description: 'Front rows with extra legroom' },
    { name: 'Preferred', rows: [4, 5], additionalPrice: 10, description: 'Mid-front rows' }
  ]
};

export function getBusLayout(busType) {
  return BUS_LAYOUTS[busType] || BUS_LAYOUTS.Standard;
}

export function getPricingTiers(busType) {
  return SEAT_PRICE_TIERS[busType] || SEAT_PRICE_TIERS.Standard;
}

export function getAvailableSeatIds(busType) {
  const layout = getBusLayout(busType);
  const maxRow = layout.maxSelectableRow || layout.totalRows;
  const seatIds = [];
  for (let row = 1; row <= maxRow; row++) {
    for (let c = 0; c < layout.columns.length; c++) {
      const id = String(row) + layout.columns[c];
      const special = layout.specialCells[id];
      if (!special || special.type === 'seat') {
        seatIds.push(id);
      }
    }
  }
  return seatIds;
}

export function getAllSeatIds(busType) {
  const layout = getBusLayout(busType);
  const seatIds = [];
  for (let row = 1; row <= layout.totalRows; row++) {
    for (let c = 0; c < layout.columns.length; c++) {
      const id = String(row) + layout.columns[c];
      const special = layout.specialCells[id];
      if (!special || special.type === 'seat') {
        seatIds.push(id);
      }
    }
  }
  return seatIds;
}

export function getPaidSeatValue(res, seatId, tiers) {
  // seatTierPrice from the API is the amount actually paid; 0 is a valid value, so a truthiness check must not skip it
  return res && typeof res.seatTierPrice === 'number' ? res.seatTierPrice : getSeatPrice(seatId, 0, null, tiers);
}

export function getSeatPrice(seatId, basePrice, busType, resolvedTiers) {
  const tiers = resolvedTiers || getPricingTiers(busType);
  const rowMatch = seatId.match(/^(\d+)/);
  if (!rowMatch) {
    return basePrice;
  }

  const rowNumber = parseInt(rowMatch[1], 10);

  for (let i = 0; i < tiers.length; i++) {
    const tier = tiers[i];
    if (tier.rows && tier.rows.indexOf(rowNumber) !== -1) {
      return basePrice + (tier.additionalPrice || 0);
    }
  }

  return basePrice;
}
